import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import axiosInstanceAuth from "../../../apiInstances/axiosInstanceAuth";
import fullRedHeart from "../../../assets/fullRedHeart.png";
import heart from "../../../assets/heart_icon.png";
import { BACKEND_BASE_URL } from "../../../apiInstances/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// Import your image here
import locationImage from "../../../assets/location.svg";

export default function HousePropertySlider({ e, savedLocalPost }) {
  const navigate = useNavigate();
  const [likeFlag, setLikeFlag] = useState(false);
  async function isfavorite(id) {
    await axiosInstanceAuth
      .post("addToFavorites", {
        id,
      })
      .then((res) => {
        if (
          res?.data?.message.trim() ===
          "This Property is added to your wishlist"
        ) {
          setLikeFlag(true);
        } else if (
          res?.data?.message.trim() ===
          "This Property is removed from your wishlist"
        ) {
          setLikeFlag(false);
        }
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        //console.log("🚀 ~ .then ~ err:", err);
      });
  }
  const GetSavedProperty = async (isActive) => {
    await axiosInstanceAuth
      .post("savedProperty", {
        status: isActive,
      })
      .then((res) => {
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          const newArray = mydata.map((obj, i) => ({
            ...obj,
            _id: mydata?.[i]?._id,
            frontPageImg: mydata?.[i]?.frontPageImg,
            lead_agent: mydata?.[i]?.lead_agent,
            price: mydata?.[i]?.price,
            street_address_number: mydata?.[i]?.street_address_number,
            street_address_name: mydata?.[i]?.street_address_name,
            suburb: mydata?.[i]?.suburb,
            favourite: mydata?.[i]?.isFavorite,
            bedroomCount: mydata?.[i]?.bedroomCount,
            showerCount: mydata?.[i]?.showerCount,
            carCount: mydata?.[i]?.carCount,
          }));

          localStorage.setItem(
            "Saved",
            mydata.map((obj, i) => `${mydata?.[i]?._id}`)
          );
        } else {
          // localStorage.clear();
          // navigate(`/`);
          // toast.error("no data found!!");
          //console.log("no data found!!");
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  useEffect(() => {
    const getToken = localStorage.getItem('Token');
    if (getToken) {
      GetSavedProperty();
    }
  }, []);
  return (
    <div className="my-3 bg-white rounded-xl w-auto min-h-[430px]" style={{ boxShadow: '0px 1px 4px 0px #00000029' }}>
      <div>
        <div
          className="cursor-pointer"
          onClick={() => navigate(`/property-house/${e?.id}`)}
        >
          <Carousel infinite={true} autoPlay={true}>
            {e?.clientImage?.map((innerimg, index) => (
              <div key={index}>
                <img
                  src={innerimg}
                  alt="img"
                  className="h-56 rounded-t-xl object-cover"
                />
              </div>
            ))}
          </Carousel>
        </div>

        <div className="px-2">
          <div className="flex justify-between mt-2 items-center ">
            <h2 className="text-md text-lg font-medium text-[#3D3B40] ">
              {e?.head?.substring(0, 15)}...
            </h2>
            <div className=" p-2 md:p-3 cursor-pointer">
              {likeFlag || savedLocalPost?.includes(e.id) ? (
                <img
                  src={fullRedHeart}
                  alt="heart"
                  className="w-4 cursor-pointer"
                  onClick={() => isfavorite(e.id)}
                />
              ) : (
                <img
                  src={heart}
                  alt="heart"
                  className="w-4 md:w-5 cursor-pointer"
                  onClick={() => {
                    isfavorite(e.id);
                  }}
                />
              )}
            </div>
          </div>

          <div className="flex justify-start items-start py-3 gap-1 ">
            <img src={locationImage} alt="img" className="-ml-[3px]" /> {/* Use your image here */}
            <p className="font-normal  text-[#3D3B40] text-sm">{e?.place}</p>
          </div>


          <div className="flex gap-4 mt-1 mb-2">
            {e?.iconWithCount?.length > 0 &&
              e?.iconWithCount?.map((elm, ind) => (
                <div key={ind} className="flex justify-center items-center rounded-md">
                  <img src={elm?.icon} alt="" className="w-4 mr-1" />
                  <div className="font-normal text-base text-[#3D3B40]">{elm?.count}</div>
                </div>
              ))}
          </div>
          <div
            className=" font-medium text-[#3D3B40] text-base "
            title={e?.discription}>
            {e?.discription.length > 40
              ? `${e.discription.slice(0, 40)}...`
              : e.discription}
          </div>
        </div>

      </div>
    </div>
  );
}
